(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const header = toggle.closest('[data-header]');
  if (!header) return;
  const open = header.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty]');
    if (!button) return;
    var wrap = button.closest('.main-cart__qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 0;
    if (button.getAttribute('data-qty') === 'minus') {
      input.value = Math.max(0, current - 1);
    } else {
      input.value = current + 1;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    const image = gallery.querySelector('[data-gallery-image]');
    const nextSrc = thumb.getAttribute('data-src');
    if (!image || !nextSrc) return;

    const picture = image.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        source.remove();
      });
    }

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = nextSrc;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      if (active) {
        item.setAttribute('aria-current', 'true');
      } else {
        item.removeAttribute('aria-current');
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  var id = 'how-to-use';

  function stickyOffset() {
    var gap = 16;
    var offset = 0;
    var nodes = document.querySelectorAll('.site-header, .section-header');

    for (var i = 0; i < nodes.length; i++) {
      var style = window.getComputedStyle(nodes[i]);
      if (style.position !== 'sticky' && style.position !== 'fixed') continue;
      var rect = nodes[i].getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > offset) offset = rect.bottom;
    }

    return Math.ceil(offset) + gap;
  }

  function align(smooth) {
    if (window.location.hash !== '#' + id) return;
    var el = document.getElementById(id);
    if (!el) return;

    el.style.scrollMarginTop = stickyOffset() + 'px';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({
      behavior: smooth && !reduceMotion ? 'smooth' : 'auto',
      block: 'start'
    });
  }

  function onReady() {
    align(true);
    window.addEventListener('hashchange', function () {
      align(true);
    });
    window.addEventListener('resize', function () {
      var el = document.getElementById(id);
      if (!el) return;
      el.style.scrollMarginTop = stickyOffset() + 'px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function perView() {
      if (window.matchMedia('(max-width: 749px)').matches) return 1;
      if (window.matchMedia('(max-width: 989px)').matches) return 2;
      return 3;
    }

    function initCarousel(root) {
      var viewport = root.querySelector('[data-results-viewport]');
      var track = root.querySelector('[data-results-track]');
      var prev = root.querySelector('[data-results-prev]');
      var next = root.querySelector('[data-results-next]');
      var dotsWrap = root.querySelector('[data-results-dots]');
      if (!viewport || !track || !prev || !next || !dotsWrap) return;

      var cards = Array.prototype.slice.call(track.children);
      if (!cards.length) return;

      var index = 0;
      var pageLabel = dotsWrap.getAttribute('aria-label') || 'Pages';

      function pageCount() {
        return Math.max(1, cards.length - perView() + 1);
      }

      function renderDots() {
        var count = pageCount();
        dotsWrap.innerHTML = '';
        for (var i = 0; i < count; i += 1) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'results__dot' + (i === index ? ' is-active' : '');
          button.setAttribute('aria-label', pageLabel + ' ' + (i + 1));
          button.setAttribute('aria-current', i === index ? 'true' : 'false');
          button.dataset.index = String(i);
          dotsWrap.appendChild(button);
        }
      }

      function syncDots() {
        var dots = dotsWrap.querySelectorAll('.results__dot');
        for (var i = 0; i < dots.length; i += 1) {
          var active = i === index;
          dots[i].classList.toggle('is-active', active);
          dots[i].setAttribute('aria-current', active ? 'true' : 'false');
        }
      }

      function update() {
        var max = pageCount() - 1;
        if (index > max) index = max;
        if (index < 0) index = 0;

        var card = track.children[0];
        if (!card) return;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        var step = card.getBoundingClientRect().width + gap;
        track.style.transform = 'translate3d(' + (-index * step) + 'px, 0, 0)';
        syncDots();
      }

      function goTo(nextIndex) {
        var max = pageCount() - 1;
        if (max <= 0) return;
        if (nextIndex < 0) index = max;
        else if (nextIndex > max) index = 0;
        else index = nextIndex;
        update();
      }

      prev.addEventListener('click', function () {
        goTo(index - 1);
      });
      next.addEventListener('click', function () {
        goTo(index + 1);
      });
      dotsWrap.addEventListener('click', function (event) {
        var target = event.target.closest('.results__dot');
        if (!target) return;
        goTo(Number(target.dataset.index) || 0);
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          var count = pageCount();
          if (dotsWrap.children.length !== count) renderDots();
          update();
        }, 120);
      });

      renderDots();
      update();
    }

    document.querySelectorAll('[data-results-carousel]').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
